module.exports = __webpack_public_path__ + "static/media/background6.4e536007.jpg";